import { modalActions } from '../slices/modalSlice'

export function showModal(modalType: string, data?: any) {
  return modalActions.showModal({
    modalType,
    data,
  })
}

export function hideModal() {
  return modalActions.hideModal()
}
